import React, { useRef, useState, useEffect } from 'react';

const BeforeAfter = ({ data }) => {
  // const { bgImg, beforeImg, afterImg } = data;

  // const containerRef = useRef(null);
  // const beforeRef = useRef(null);
  // const handleRef = useRef(null);

  // const [maxX, setMaxX] = useState(0);
  // const [offsetX, setOffsetX] = useState(0);

  // useEffect(() => {
  //   const container = containerRef.current;
  //   if (!container) return;

  //   const updateDimensions = () => {
  //     setMaxX(container.offsetWidth);
  //     setOffsetX(container.getBoundingClientRect().left);
  //   };

  //   updateDimensions();
  //   window.addEventListener('resize', updateDimensions);

  //   const moveSlider = clientX => {
  //     const curX = clientX - offsetX;
  //     let curPos = (curX / maxX) * 100;
  //     if (curPos > 100) curPos = 100;
  //     if (curPos < 0) curPos = 0;

  //     beforeRef.current.style.right = `${100 - curPos}%`;
  //     handleRef.current.style.left = `${curPos}%`;
  //   };

  //   const onMouseDown = e => {
  //     e.preventDefault();
  //     document.addEventListener('mousemove', onMouseMove);
  //     document.addEventListener('mouseup', onMouseUp);
  //   };

  //   const onMouseMove = e => {
  //     e.preventDefault();
  //     moveSlider(e.clientX);
  //   };

  //   const onMouseUp = () => {
  //     document.removeEventListener('mousemove', onMouseMove);
  //     document.removeEventListener('mouseup', onMouseUp);
  //   };

  //   const onTouchStart = e => {
  //     moveSlider(e.touches[0].clientX);
  //     document.addEventListener('touchmove', onTouchMove, { passive: false });
  //     document.addEventListener('touchend', onTouchEnd);
  //   };

  //   const onTouchMove = e => {
  //     e.preventDefault(); // Important for mobile
  //     moveSlider(e.touches[0].clientX);
  //   };

  //   const onTouchEnd = () => {
  //     document.removeEventListener('touchmove', onTouchMove);
  //     document.removeEventListener('touchend', onTouchEnd);
  //   };

  //   const handle = handleRef.current;
  //   handle.addEventListener('mousedown', onMouseDown);
  //   handle.addEventListener('touchstart', onTouchStart, { passive: false });

  //   return () => {
  //     window.removeEventListener('resize', updateDimensions);
  //     handle.removeEventListener('mousedown', onMouseDown);
  //     handle.removeEventListener('touchstart', onTouchStart);
  //     document.removeEventListener('mousemove', onMouseMove);
  //     document.removeEventListener('mouseup', onMouseUp);
  //     document.removeEventListener('touchmove', onTouchMove);
  //     document.removeEventListener('touchend', onTouchEnd);
  //   };
  // }, [maxX, offsetX]);

  return null;
};

export default BeforeAfter;
